import React from 'react'
import styled from '@emotion/styled'

import { colors, colorState } from 'Constants'

import GridRow from 'Components/Grid/GridRow'
import Report from 'Components/Report'
import ReportHeader from '../../components/ReportHeader'
import MessageReport from './MessageReport'

const MessageGridItem = styled.div`
  background-color: ${colorState.get().message};
  color: white;
`

const TotalMessageRow = ({ row: message }) => (
  <>
    <GridRow noBackground>
      <MessageGridItem>Total</MessageGridItem>
      {Object.keys(message.message).map(item => {
        return <MessageGridItem>{message.message[item]}</MessageGridItem>
      })}
    </GridRow>
  </>
)

const totalColumns = [{ header: 'Total', property: '', size: '2x' }]

export default ({ report, categories }) => {
  const columnCategories = categories.map(item => {
    return { header: item.name, property: item.code }
  })

  const cardValues = report.totalCategoryCount
    .filter(item => item.total_count > 0)
    .sort((a, b) => parseInt(a.total_count) - parseFloat(a.total_count))
    .map(item => {
      return ['Total', item['name'], item.total_count]
    })
    .slice(0, 5) // show top 5 most count

  const totalCountRows = report.totalCategoryCount.reduce((acc, item) => {
    acc[item.code] = item.total_count
    return acc
  }, {})

  return (
    <>
      <ReportHeader
        header="Office"
        title={report.title}
        cardValues={cardValues}
      />
      {Object.values(report.doctors).length === 0 && (
        <div
          style={{
            textAlign: 'center',
            padding: '16px 0',
            margin: '16px 0',
            borderBottom: `1px solid ${colors.borderColor}`
          }}
        >
          There are no items in this office
        </div>
      )}
      {Object.keys(report.doctors).map(initials => (
        <>
          <MessageReport
            doctor={report.doctors[initials]}
            initials={initials}
            columnCategories={columnCategories}
          />
          <hr
            style={{
              width: '100%',
              border: `1px solid ${colors.borderColor}`
            }}
          />
        </>
      ))}
      <Report
        id="totalMessage"
        report={{ totalMessageReport: [{ message: totalCountRows }] }}
        columns={[...totalColumns, ...columnCategories]}
        ReportRow={TotalMessageRow}
        defaultSortIndex={0}
        prop="totalMessageReport"
      />
    </>
  )
}
